import Checkbox from '@/components/Checkbox';
import { Tag } from '@/components/Tag';
import type { AgentApiCandidateImportRequestsTmpCandidateProfile } from '@/types/serializers';
import { MdCheckCircle, MdError } from 'react-icons/md';

interface Props {
  candidates: AgentApiCandidateImportRequestsTmpCandidateProfile[];
  selectedIds: number[];
  onSelectionChange: (ids: number[]) => void;
}

export function CandidateImportDuplicateCheckList({
  candidates,
  selectedIds,
  onSelectionChange,
}: Props) {
  const allSelected = candidates.length > 0 && selectedIds.length === candidates.length;
  const someSelected = selectedIds.length > 0 && selectedIds.length < candidates.length;

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      onSelectionChange(candidates.map((c) => c.id));
    } else {
      onSelectionChange([]);
    }
  };

  const handleSelectCandidate = (candidateId: number, checked: boolean) => {
    if (checked) {
      onSelectionChange([...selectedIds, candidateId]);
    } else {
      onSelectionChange(selectedIds.filter((id) => id !== candidateId));
    }
  };

  const getDuplicateTag = (candidate: AgentApiCandidateImportRequestsTmpCandidateProfile) => {
    if (candidate.is_duplicate_record) {
      return (
        <Tag color="red" size="md" className="flex w-[180px] justify-center gap-xxs">
          <MdError className="text-base opacity-50" />
          既存データ内に重複あり
        </Tag>
      );
    }

    if (candidate.is_duplicate_csv) {
      return (
        <Tag color="red" size="md" className="flex w-[180px] justify-center gap-xxs">
          <MdError className="text-base opacity-50" />
          CSV内に重複あり
        </Tag>
      );
    }

    return (
      <Tag color="green" size="md" className="flex w-[180px] justify-center gap-xxs">
        <MdCheckCircle className="text-base opacity-50" />
        重複なし
      </Tag>
    );
  };

  return (
    <div className="flex flex-col">
      {/* ヘッダー行 */}
      <div className="flex items-center gap-4 border-b border-border bg-gray px-4 py-2">
        <Checkbox checked={allSelected} onChange={handleSelectAll} indeterminate={someSelected} />
        <div className="flex-1">
          <p className="text-heading-xxs text-sub">氏名</p>
        </div>
        <div className="w-24">
          <p className="text-heading-xxs text-sub">データ重複</p>
        </div>
      </div>

      {/* 候補者リスト */}
      {candidates.map((candidate) => (
        <div key={candidate.id} className="flex items-center gap-4 border-b border-border p-4">
          <Checkbox
            checked={selectedIds.includes(candidate.id)}
            onChange={(checked) => handleSelectCandidate(candidate.id, checked)}
          />
          <div className="flex-1">
            <p className="text-heading-sm">{candidate.name || '名前なし'}</p>
          </div>
          <div className="flex w-[180px] justify-end">{getDuplicateTag(candidate)}</div>
        </div>
      ))}

      {candidates.length === 0 && (
        <div className="flex items-center justify-center py-10">
          <p className="text-body-md text-sub">候補者データがありません</p>
        </div>
      )}
    </div>
  );
}
